import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

const Header = ({id, version, modifiers, speed, opacity, rotation}) => {
  const data = useStaticQuery(graphql`
  query{
    circle1: file(relativePath: { eq: "Zoom_Circle-1.png" }) {
        childImageSharp {
          fixed(width:250, height:250, quality:100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
     circle2: file(relativePath: { eq: "Zoom_Circle-2.png" }) {
        childImageSharp {
          fixed(width:250, height:250, quality:100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
  }
  `)


  const v = (version==='black' || version == 2)?2:1;
  return(
    <div id={id} className={`circle-wrap parallax ${modifiers || ''}`} data-speed={ speed || 1 } style={{
      // top:`${top || 0}`,
      // left: (dir==='right')?`auto`:`${dirVal || 0}`,
      // right: (dir==='right')?`${dirVal || 0}`:`auto`,
      opacity: parseFloat(opacity||0.8),
      transform: `rotate(${rotation||0})`
    }}>
      <Img fixed={data[`circle${v}`].childImageSharp.fixed} className={`circle`} />
    </div>)
}


export default Header
